<template>
  <div
    class="bar-wrapper"
    :class="{ playing: isPlaying }"
  >
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
    <div class="bar" />
  </div>
</template>

<script>
export default {
  name: "PlayerPopoutSoundIcon",
  props: {
    isPlaying: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.bar-wrapper {
  position: relative;
}

.bar {
  background: #fff;
  border-radius: 2px;
  bottom: 1px;
  height: 4px;
  position: absolute;
  width: 2px;
  top: 50%;
  transform: translateY(-50%);
}

.playing {
  :deep(.bar) {
    animation: sound 0ms -800ms linear infinite alternate;
  }
}

@keyframes sound {
  0% {
    height: 4px;
  }

  100% {
    height: 20px;
  }
}

.bar:nth-child(1) {
  left: 0;
  height: 14px;
  animation-duration: 474ms;
}

.bar:nth-child(2) {
  left: 4px;
  height: 20px;
  animation-duration: 407ms;
}

.bar:nth-child(3) {
  left: 8px;
  height: 12px;
  animation-duration: 433ms;
}

.bar:nth-child(4) {
  left: 12px;
  height: 6px;
  animation-duration: 458ms;
}

.bar:nth-child(5) {
  left: 16px;
  height: 12px;
  animation-duration: 400ms;
}
</style>
